<template>
  <router-view :key="key"></router-view>
</template>

<script>
export default {
  name: "App",
  computed: {
    key() {
      return this.$route.path + Math.random();
    }
  }
};
</script>